const appKitRouteSuffixes = ['walletconnect', 'payment'] as const;

const normalizePathname = (pathname: string): string => {
  const trimmed = pathname.replace(/\/+$/, '');
  return trimmed || '/';
};

export const isAppKitRoute = (pathname: string = window.location.pathname): boolean => {
  const normalized = normalizePathname(pathname).toLowerCase();

  return appKitRouteSuffixes.some((route) => normalized === `/${route}` || normalized.endsWith(`/${route}`));
};

/**
 * AppKit / wagmi 僅在 WalletConnect 相關路由需要。
 * 其他 SSO（Passkey、Google 等）不應初始化，避免本地開發時噴錯。
 *
 * 設 `DISABLE_APPKIT=true` 可強制關閉（含 walletconnect 路由）。
 */
export const isAppKitEnabled = (pathname: string = window.location.pathname): boolean => {
  if (window._env_?.DISABLE_APPKIT === 'true') {
    return false;
  }

  return isAppKitRoute(pathname);
};
